module.exports = __webpack_public_path__ + "static/Collage Agosto-6b0229f1b6e8c05d47b855558afdd91a.png";